/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck

import React, { useEffect, useState } from 'react';
import { Collapse, Col, Row, Button } from 'react-bootstrap';
import { SelectableCardContainer } from '@vlinder-web/selectable-card-container-widget-react';
import { CoverageSlider } from './components';
import { ListItemsComp } from '../../../../widgets/list-items-widget-react';
import { useTheme } from '../../../../providers/theme';
import './styles.css';
import * as S from './styles';

export interface ICardCompProps {
  submitButtonTitle?: string;
  options?: any[];
  country?: string;
  headers?: string[];
  selectedPolicy?: any;
  initialAmount?: number;
  premiumText?: string;
  premiumCycle?: string;
  onPolicySubmit?(policyOption: any): void;
  onSliderValueChange(type: string, value: number): void;
}

export const PolicyOptions = (props: ICardCompProps) => {
  const {
    options,
    premiumCycle,
    submitButtonTitle,
    selectedPolicy,
    country,
    initialAmount,
    premiumText,
    headers,
    onPolicySubmit,
    onSliderValueChange,
  } = props;
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(selectedPolicy);
  const [policyOptions, setPolicyOptions] = useState(
    options?.map((u) => ({ ...u, open: false }))
  );

  useEffect(() => {
    let _tempOptions = options?.map((u) => ({ ...u, open: false }));
    setPolicyOptions(_tempOptions);
  }, [options]);

  const onPolicySelectSubmit = () => {
    console.log(`on policy selection submit`);
    onPolicySubmit && onPolicySubmit(selected);
  };

  const onSliderChange = (type: string, value: number) => {
    if (selected) {
      setSelected(null);
    }
    onSliderValueChange && onSliderValueChange(type, value);
  };

  const onShowMoreClick = (key: string) => {
    const newOptions = policyOptions?.map((u) =>
      u.id === key ? { ...u, isOpen: !u?.isOpen } : { ...u, isOpen: false }
    );
    setPolicyOptions(newOptions);
  };

  const _getListItems = (item: any) => {
    let tempList: any = [];
    Array.isArray(item?.triggeringParams) &&
      item?.triggeringParams?.map((key: any) => {
        tempList.push({
          percent: `${key?.coveragePct}%`,
          title: Object.values(key?.params[0]),
          value: key?.coverage?.formatted,
        });
      });
    return tempList;
  };

  return (
    <>
      <CoverageSlider
        onValueChange={onSliderChange}
        country={country}
        initialAmount={initialAmount}
      />
      {Array.isArray(options) &&
        policyOptions?.map((item) => {
          return (
            <SelectableCardContainer
              isSelected={item?.id === selected?.id}
              selectedColor={theme?.colors?.secondary}
              key={item?.id}
            >
              <div class="card-body" onClick={() => setSelected(item)}>
                <S.Heading color={theme?.colors?.primary}>
                  {item?.label}
                </S.Heading>
                <S.SubHead>{item?.subTitle}</S.SubHead>
                {/* <a
                  onClick={() => onShowMoreClick(item?.id)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                > */}
                <S.Show>
                  <a
                    onClick={() => onShowMoreClick(item?.id)}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                  >
                    {item?.isOpen ? 'Show less...' : 'Show more...'}
                  </a>
                </S.Show>
                {/* </a> */}
                <Collapse in={item?.isOpen}>
                  <div id="example-collapse-text">
                    <ListItemsComp
                      listItems={_getListItems(item)}
                      headers={headers}
                    />
                  </div>
                </Collapse>
              </div>
              <div class="card-footer ">
                <Row>
                  <Col>
                    <S.Footer>
                      {premiumText} {item?.premium?.formatted}/{premiumCycle}
                    </S.Footer>{' '}
                  </Col>
                </Row>
              </div>
            </SelectableCardContainer>
          );
        })}
      <div style={{ marginTop: '5%' }}>
        <Button
          className="text-dark me-3"
          variant="secondary"
          style={{ float: 'right' }}
          disabled={!selected}
          size="lg"
          onClick={onPolicySelectSubmit}
        >
          {submitButtonTitle}
        </Button>
      </div>
    </>
  );
};

PolicyOptions.defaultProps = {
  options: [],
  premiumText: 'Premium',
  premiumCycle: 'Month',
  submitButtonTitle: 'Next',
};
